<template>
  <div class="container">
    <!-- 面包屑导航 -->
    <breadcrumb :breadcrumbConfig="breadcrumbConfig"></breadcrumb>

    <!-- 面包屑导航 teamManage -->

    <div class="contentDetails">
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div class="title titleblue">售后详情</div>
      </div>
    </div>
    <div class="contentDetails">
      <div class="box">
        <Steps
          v-if="routeQuery.afterType == 0"
          :stepInfo="afterSaleNode"
        ></Steps>
        <Steps1
          v-if="routeQuery.afterType == 1"
          :stepInfo="afterSaleNode"
        ></Steps1>
        <Steps2
          v-if="routeQuery.afterType == 2"
          :stepInfo="afterSaleNode"
        ></Steps2>
      </div>
    </div>
    <div
      class="contentDetails"
      style="display: flex; justify-content: space-between"
    >
      <!-- <div v-if="routeQuery.afterType == 0">
        <div
          style="display: flex; align-items: center"
          v-if="routeQuery.afterType == 0"
        >
          <img :src="statusImg.close" style="margin-right: 8px" /><span
            class="boldSize"
          >
            {{
              (orderMessage.status == 1 ? "待审核" : "") ||
              (orderMessage.status == 7 ? "售后申请已取消" : "") ||
              (orderMessage.status == 2 ? "已驳回退款申请" : "") ||
              (orderMessage.status == 8 ? "已退款" : "")
            }}
          </span>
        </div>
        <div v-if="orderMessage.status == 1" style="margin-top: 10px">
          请及时审核
        </div>
        <div v-if="orderMessage.status == 2" style="margin-top: 10px">
          {{ orderMessage.approveRemark }}
        </div>
        <div v-if="orderMessage.status == 7" style="margin-top: 10px">
          <div>用户已手动取消售后申请！</div>
          <div>时间：{{ orderMessage.createdTime }}</div>
        </div>
        <div v-if="orderMessage.status == 8" style="margin-top: 10px">
          退款金额已退回买家账户！
        </div>
      </div>
      <div v-if="routeQuery.afterType == 1">
        <div style="display: flex; align-items: center">
          <img :src="statusImg.close" style="margin-right: 8px" /><span
            class="boldSize"
          >
            {{
              (orderMessage.status == 1 ? "待审核" : "") ||
              (orderMessage.status == 3 ? "申请已通过，待买家寄回商品" : "") ||
              (orderMessage.status == 2 ? "驳回理由" : "") ||
              (orderMessage.status == 7 ? "售后申请已取消" : "") ||
              (orderMessage.status == 8 ? "售后完成，已成功退款" : "") ||
              (orderMessage.status == 4 ? "买家已寄回，待卖家签收" : "")
            }}
          </span>
        </div>
        <div v-if="orderMessage.status == 1" style="margin-top: 10px">
          请及时审核
        </div>
        <div v-if="orderMessage.status == 3" style="margin-top: 10px">
          <div>买家寄回中...</div>
        </div>
        <div v-if="orderMessage.status == 4" style="margin-top: 10px">
          <div v-if="orderMessage.orderInfo">
            物流公司：{{ orderMessage.orderInfo.logisticsCompany }}
          </div>
          <div v-if="orderMessage.orderInfo" style="margin-top: 10px">
            物流订单：{{ orderMessage.orderInfo.logisticsNumber }}
          </div>
        </div>
        <div v-if="orderMessage.status == 8" style="margin-top: 10px">
          完成时间：{{ orderMessage.orderInfo.completeTime }}
        </div>
        <div v-if="orderMessage.status == 2" style="margin-top: 10px">
          {{ orderMessage.afterRemark }}
        </div>
        <div v-if="orderMessage.status == 7" style="margin-top: 10px">
          <div>用户已手动取消售后申请！</div>
          <div>时间：{{ orderMessage.createdTime }}</div>
        </div>
      </div> -->
      <div
        style="
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 400;
          line-height: 30px;
          color: #333333;
        "
      >
        <div style="display: flex; align-items: center">
          <img :src="statusImg.close" style="margin-right: 8px" /><span
            class="boldSize"
          >
            {{
              (orderMessage.status == 1 ? "待审核" : "") ||
              (orderMessage.status == 3 ? "申请已通过，待买家寄回商品" : "") ||
              (orderMessage.status == 2 ? "驳回理由" : "") ||
              (orderMessage.status == 4 ? "买家已寄回，待卖家签收" : "") ||
              (orderMessage.status == 7 ? "售后申请已取消" : "") ||
              (orderMessage.status == 5
                ? "买家寄回商品已签收，待卖家换货寄出"
                : "") ||
              (orderMessage.status == 6
                ? "卖家已寄出换货商品，待买家签收"
                : "") ||
              (orderMessage.status == 8 && orderMessage.afterType == 0
                ? "已退款"
                : "") ||
              (orderMessage.status == 8 && orderMessage.afterType == 1
                ? "售后完成，已成功退款"
                : "") ||
              (orderMessage.status == 8 && orderMessage.afterType == 2
                ? "买家已签收"
                : "")
            }}
          </span>
        </div>
        <div v-if="orderMessage.status == 1" style="margin-top: 10px">
          请及时审核
        </div>
        <div v-if="orderMessage.status == 2" style="margin-top: 10px">
          {{ orderMessage.approveRemark }}
        </div>
        <div v-if="orderMessage.status == 3" style="margin-top: 10px">
          <div>买家寄回中...</div>
        </div>
        <div v-if="orderMessage.status == 7" style="margin-top: 10px">
          <div>用户已手动取消售后申请！</div>
          <div style="color: #666666; font-size: 16px">
            时间：{{ orderMessage.createdTime }}
          </div>
        </div>
        <div v-if="orderMessage.status == 4" style="margin-top: 10px">
          <div v-if="backInfo">
            物流公司：{{ backInfo.logisticsCompanyLabel }}
          </div>
          <div v-if="backInfo" style="margin-top: 10px">
            物流订单：{{ backInfo.logisticsNumber }}
          </div>
        </div>
        <div v-if="orderMessage.status == 6">
          <div>出货信息</div>
          <div style="display: flex">
            <div style="color: rgb(97, 144, 237); font-size: 16px">运输中</div>
            <div
              v-if="backInfo"
              style="color: #666666; font-size: 16px; margin-left: 10px"
            >
              物流公司：{{ backInfo.logisticsCompanyLabel }}
            </div>
            <div
              v-if="backInfo"
              style="margin-left: 10px; color: #666666; font-size: 16px"
            >
              物流订单：{{ backInfo.logisticsNumber }}
            </div>
          </div>
        </div>
        <div v-if="orderMessage.status == 5">
          <div>出货信息</div>
          <div style="color: rgb(97, 144, 237); font-size: 16px">
            等待寄出换货
          </div>
        </div>
        <div v-if="orderMessage.status == 8 && orderMessage.afterType == 0">
          <div>退款金额已退回买家账户！</div>
        </div>
        <div v-if="orderMessage.status == 8 && orderMessage.afterType == 2">
          <div style="display: flex">
            <div v-if="backInfo">
              物流公司：{{ backInfo.logisticsCompanyLabel }}
            </div>
            <div v-if="backInfo" style="margin-left: 10px">
              物流订单：{{ backInfo.logisticsNumber }}
            </div>
          </div>
        </div>
        <div v-if="orderMessage.status == 8 && orderMessage.afterType == 1">
          <div>完成时间：{{ orderMessage.completeTime }}</div>
        </div>
      </div>
      <div class="logisticsBtn" v-if="routeQuery.afterType == 0">
        <!-- <el-button
          v-if="orderMessage.status == 1"
          type="primary"
          size="medium"
          @click="applyDialog"
          plain
          >审核申请</el-button
        > -->
      </div>
      <div class="logisticsBtn" v-if="routeQuery.afterType == 1">
        <el-button
          v-if="orderMessage.status == 1"
          class="whiteBtn"
          @click="applyDialog"
          >审核申请</el-button
        >
        <el-button
          v-if="orderMessage.status == 3"
          class="whiteBtn"
          @click="outGoods('fedit')"
          >填写退货单号</el-button
        >
        <el-button
          v-if="orderMessage.status == 4"
          class="whiteBtn"
          @click="stock('five')"
          >确认收货</el-button
        >
        <el-button
          v-if="orderMessage.status == 6"
          class="whiteBtn"
          @click="stock('user')"
          >确认收货</el-button
        >
        <el-button
          v-if="orderMessage.status == 4 || orderMessage.status == 8"
          class="whiteBtn"
          @click="examine(1)"
          >查看物流</el-button
        >
      </div>
      <div class="logisticsBtn" v-if="routeQuery.afterType == 2">
        <el-button
          v-if="orderMessage.status == 1"
          class="whiteBtn"
          @click="applyDialog"
          >审核申请</el-button
        >
        <el-button
          v-if="orderMessage.status == 4"
          class="whiteBtn"
          @click="stock('five')"
          >确认收货</el-button
        >
        <el-button
          v-if="orderMessage.status == 6"
          class="whiteBtn"
          @click="stock('user')"
          >确认收货</el-button
        >
        <el-button
          v-if="orderMessage.status == 5"
          class="whiteBtn"
          @click="outGoods('delivery')"
          >寄出换货</el-button
        >
        <el-button
          v-if="orderMessage.status == 4"
          class="whiteBtn"
          @click="examine(1)"
          >查看物流</el-button
        >
        <el-button
          v-if="orderMessage.status == 6 || orderMessage.status == 8"
          class="whiteBtn"
          @click="examine(2)"
          >查看物流</el-button
        >
      </div>
    </div>
    <!-- 订单信息 -->
    <!-- 订单信息 -->
    <div class="contentDetails">
      <div class="title">订单信息</div>
      <div class="order_details">
        <div class="order_details_box">
          <div class="order_details_item">
            <span class="order_details_title">订单编号</span
            ><span class="order_details_value" v-if="orderMessage.orderInfo">{{
              orderMessage.orderInfo.orderNo
                ? orderMessage.orderInfo.orderNo
                : "-"
            }}</span>
          </div>
        </div>
        <div class="blankBox"></div>
        <div class="order_details_box">
          <div class="order_details_item">
            <span class="order_details_title">订单类型</span
            ><span class="order_details_value" v-if="orderMessage.orderInfo">{{
              orderMessage.orderInfo.orderTypeLabel
                ? orderMessage.orderInfo.orderTypeLabel
                : "-"
            }}</span>
          </div>
        </div>
        <div class="blankBox"></div>
        <div class="order_details_box">
          <div class="order_details_item">
            <span class="order_details_title">支付方式</span
            ><span class="order_details_value">在线支付</span>
          </div>
        </div>
        <div class="blankBox"></div>
        <div class="order_details_box">
          <div class="order_details_item">
            <span class="order_details_title">支付时间</span
            ><span class="order_details_value" v-if="orderMessage.orderInfo">{{
              orderMessage.orderInfo.payTime
                ? orderMessage.orderInfo.payTime
                : "-"
            }}</span>
          </div>
        </div>
      </div>
      <div class="remarkMessage">
        <div class="remarkMessage_remark">
          <div class="remarkMessage_remark_item">
            <span class="fourteenTitle">备注信息</span>
            <span class="fourteenDetails" v-if="orderMessage.orderInfo">{{
              orderMessage.orderInfo.userRemark
                ? orderMessage.orderInfo.userRemark
                : "暂无备注 "
            }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 购买信息 -->
    <div class="contentDetails">
      <div class="title">购买信息</div>
      <div class="contentDetails_box">
        <div class="contentDetails_item">
          <div class="title_too">收货信息</div>
          <div class="details">
            <div class="details_item">
              <span class="details_title fourteen">收货人</span
              ><span
                class="details_value fourteen"
                v-if="orderMessage.orderInfo"
                >{{
                  orderMessage.orderInfo.postName
                    ? orderMessage.orderInfo.postName
                    : "-"
                }}</span
              >
            </div>
            <div class="details_item">
              <span class="details_title fourteen">联系方式</span
              ><span
                class="details_value fourteen"
                v-if="orderMessage.orderInfo"
                >{{
                  orderMessage.orderInfo.postPhone
                    ? orderMessage.orderInfo.postPhone
                    : "-"
                }}</span
              >
            </div>
            <div class="details_item addressWidth">
              <span class="details_title fourteen">收货地址</span
              ><span
                class="details_value fourteen"
                v-if="orderMessage.orderInfo"
                >{{ orderMessage.orderInfo.postDistrictAddress }}&nbsp;{{
                  orderMessage.orderInfo.postAddress
                }}</span
              >
            </div>
          </div>
        </div>
        <div class="borderWire"></div>
        <div class="contentDetails_item">
          <div class="title_too">买家信息</div>
          <div class="details">
            <div class="details_item">
              <span class="details_title fourteen">客户姓名</span
              ><span
                class="details_value fourteen"
                v-if="orderMessage.orderInfo"
                >{{
                  orderMessage.orderInfo.userName
                    ? orderMessage.orderInfo.userName
                    : "-"
                }}</span
              >
            </div>
            <div class="details_item">
              <span class="details_title fourteen">客户电话</span
              ><span
                class="details_value fourteen"
                v-if="orderMessage.orderInfo"
                >{{
                  orderMessage.orderInfo.userPhone
                    ? orderMessage.orderInfo.userPhone
                    : "-"
                }}</span
              >
            </div>
          </div>
        </div>
        <div class="borderWire"></div>
        <div class="contentDetails_item">
          <div class="title_too">来源平台</div>
          <div class="details">
            <div class="details_item">
              <span class="details_title fourteen">来源平台</span
              ><span
                class="details_value fourteen"
                v-if="orderMessage.orderInfo"
                >{{
                  orderMessage.platformLabel ? orderMessage.platformLabel : "-"
                }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contentDetails">
      <div class="titleBtn">
        <div class="title" style="margin-bottom: 20px">商品信息</div>
      </div>
      <el-table
        :data="orderDetailList1"
        :header-cell-style="{ background: '#fafafa', color: '#333333' }"
        class="goodsMessage"
      >
        <el-table-column prop="updatedTime" label="商品信息" headerAlign="left">
          <template slot-scope="props">
            <div style="text-align: left">
              <p>
                <span>{{
                  props.row.goodsName ? props.row.goodsName : "-"
                }}</span
                ><span v-if="props.row.goodsType == 3" class="gift">赠品</span>
              </p>
              <p>{{ props.row.goodsSkuName ? props.row.goodsSkuName : "-" }}</p>
              <p>
                <span style="padding-right: 10px">商品编码</span
                >{{ props.row.goodsSkuNo ? props.row.goodsSkuNo : "-" }}
              </p>
              <!-- <p>
                <span style="padding-right: 10px">商家编码</span
                >{{ props.row.merchantCode ? props.row.merchantCode : "-" }}
              </p> -->
              <!-- <p><span style="padding-right:10px">商家编码</span> -</p> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="authListStr"
          label="单价/数量"
          header-align="right"
        >
          <template slot-scope="props">
            <div style="text-align: right">
              <p>￥&nbsp;{{ Number(props.row.retailPrice).toFixed(2) }}</p>
              <p>×&nbsp;{{ props.row.afterQuantity }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="authListStr" label="运费" header-align="right">
          <template slot-scope="props">
            <div style="text-align: right">
              ￥&nbsp;{{ Number(props.row.freightAmount).toFixed(2) }}
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="authListStr" label="优惠" header-align="right">
          <template slot-scope="props">
            <div style="text-align: right">￥0.00</div>
          </template>
        </el-table-column> -->
        <el-table-column prop="authListStr" label="小计" header-align="right">
          <template slot-scope="props">
            <div style="text-align: right">
              ￥&nbsp;{{
                Number(props.row.afterQuantity * props.row.retailPrice).toFixed(
                  2
                )
              }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="fourteenDetails_title">优惠信息</div>
      <div v-if="orderMessage.discountLabel">
        <p>{{ orderMessage.discountLabel }}</p>
      </div>
      <template v-else>
        <div
          class="fourteenDetails"
          style="
            margin-top: 12px;
            border-bottom: 1px solid #ededed;
            padding-bottom: 20px;
          "
        >
          无优惠
        </div>
      </template>
      <div
        class="titleBtn"
        v-if="routeQuery.afterType == 0 && orderDetailList2.length != 0"
      >
        <div class="title" style="margin-bottom: 20px; margin-top: 20px">
          赠品商品
        </div>
      </div>
      <el-table
        v-if="routeQuery.afterType == 0 && orderDetailList2.length != 0"
        :data="orderDetailList2"
        :header-cell-style="{ background: '#fafafa', color: '#333333' }"
        class="goodsMessage"
      >
        <el-table-column prop="updatedTime" label="商品信息">
          <template slot-scope="props">
            <div style="text-align: left">
              <p>
                <span>{{
                  props.row.goodsName ? props.row.goodsName : "-"
                }}</span>
              </p>
              <p>{{ props.row.goodsSkuName ? props.row.goodsSkuName : "-" }}</p>
              <p>
                <span style="padding-right: 10px">商品编码</span
                >{{ props.row.goodsSkuNo ? props.row.goodsSkuNo : "-" }}
              </p>
              <!-- <p>
                <span style="padding-right: 10px">商家编码</span
                >{{ props.row.merchantCode ? props.row.merchantCode : "-" }}
              </p> -->
              <!-- <p><span style="padding-right:10px">商家编码</span> -</p> -->
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="authListStr"
          label="单价/数量"
          header-align="center"
        >
          <template slot-scope="props">
            <div style="text-align: center">
              <p>￥&nbsp;{{ Number(props.row.retailPrice).toFixed(2) }}</p>
              <p>×&nbsp;{{ props.row.afterQuantity }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="authListStr" label="小计" header-align="center">
          <template slot-scope="props">
            <div style="text-align: center">
              ￥&nbsp;{{
                Number(props.row.afterQuantity * props.row.retailPrice).toFixed(
                  2
                )
              }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="total_prices">
        <span
          style="color: #666666; margin-right: 15px"
          v-if="orderMessage.orderInfo && orderMessage.afterType == 0"
          >商品总价：￥{{
            Number(orderMessage.orderInfo.goodsAmount).toFixed(2) || "0.00"
          }}</span
        >
        <span
          style="color: #666666; margin-right: 15px"
          v-if="
            (orderMessage.afterType == 1 || orderMessage.afterType == 2) &&
            orderMessage.orderAfterDetailList
          "
          >商品总价：￥{{
            Number(
              orderMessage.orderAfterDetailList[0].retailPrice *
                orderMessage.orderAfterDetailList[0].afterQuantity
            ).toFixed(2) || "0.00"
          }}</span
        >
        <span
          style="color: #666666; margin-right: 15px"
          v-if="orderMessage.orderInfo && orderMessage.afterType == 0"
          >运费：￥{{ orderMessage.orderInfo.freightAmount || 0 }}</span
        ><!-- 暂时咩有 -->
        <span
          style="color: #666666; margin-right: 15px"
          v-if="
            (orderMessage.afterType == 1 || orderMessage.afterType == 2) &&
            orderMessage.orderAfterDetailList
          "
          >运费：￥{{
            Number(orderMessage.orderAfterDetailList[0].freightAmount).toFixed(
              2
            ) || "0.00"
          }}</span
        >
        <span style="color: red; margin-right: 15px"
          >优惠：￥{{
            orderMessage.discountAmount
              ? Number(orderMessage.discountAmount).toFixed(2)
              : "0.00"
          }}</span
        ><!-- 暂时咩有 -->
        <span
          style="color: #444; margin-right: 15px"
          v-if="orderMessage.afterType == 0"
          >应付：￥{{ Number(orderMessage.refundMoney).toFixed(2) }}</span
        >
        <span
          style="color: #444; margin-right: 15px"
          v-if="
            (orderMessage.afterType == 1 || orderMessage.afterType == 2) &&
            orderMessage.orderAfterDetailList
          "
          >应付：￥{{
            Number(
              orderMessage.orderAfterDetailList[0].refundMoney +
                orderMessage.orderAfterDetailList[0].freightAmount
            ).toFixed(2)
          }}</span
        >
        <span style="color: #6190ed; margin-right: 15px"
          >（实付：￥{{ Number(orderMessage.refundMoney).toFixed(2) }}）</span
        >
        <!-- <span
          style="color: #6190ed; margin-right: 15px"
          v-if="
            (orderMessage.afterType == 1 || orderMessage.afterType == 2) &&
            orderMessage.orderAfterDetailList
          "
          >（实付：￥{{
            Number(
              orderMessage.orderAfterDetailList[0].refundMoney +
                orderMessage.orderAfterDetailList[0].freightAmount
            ).toFixed(2)
          }}）</span
        > -->
        <span
          style="color: red"
          v-if="orderMessage.afterType == 0 || orderMessage.afterType == 1"
          >应退款金额：￥{{ Number(orderMessage.refundMoney).toFixed(2) }}</span
        >
        <!-- <span
          style="color: red"
          v-if="
            orderMessage.afterType == 1 && orderMessage.orderAfterDetailList
          "
          >应退款金额：￥{{
            Number(orderMessage.orderAfterDetailList[0].refundMoney).toFixed(2)
          }}</span
        >  -->
      </div>
      <div class="afterSaleBox">
        <div class="afterSaleBox_item">
          <div class="afterSaleBox_title">售后信息</div>
        </div>
        <div class="afterSaleBox_item">
          <div class="message">
            <p>
              <span>退款编号:</span
              ><span class="message_value">{{ orderMessage.afterNo }}</span>
            </p>
            <p>
              <span>售后类型:</span
              ><span class="message_value">{{
                orderMessage.afterTypeLabel
              }}</span>
            </p>
            <p>
              <span>售后原因:</span
              ><span class="message_value">{{
                orderMessage.afterReasonLabel
              }}</span>
            </p>
            <p>
              <span>售后说明:</span
              ><span class="message_value">{{
                orderMessage.afterRemark ? orderMessage.afterRemark : "-"
              }}</span>
            </p>
            <!-- <p><span>物流部备注:</span><span class="message_value">{{afterSaleMessage.refundReason }}</span></p> -->
          </div>
          <div class="imgbox">
            <span class="imgbox_title">图片：</span>
            <el-image
              style="cursor: pointer"
              v-for="(item, index) in imgs"
              :key="index"
              class="img_item"
              @click="look(item)"
              :src="item"
              lazy
            ></el-image>
          </div>
        </div>
        <div class="tuikuan" v-if="orderMessage.afterType != 2">
          <span class="tuikuan_status">{{
            type == "accomplish"
              ? "退款成功"
              : "" || type == "afterSaleclose"
              ? "退款失败"
              : ""
          }}</span>
          <span
            class="money"
            v-if="
              orderMessage.status == 1 ||
              orderMessage.status == 2 ||
              orderMessage.status == 7 ||
              orderMessage.status == 3 ||
              orderMessage.status == 4 ||
              orderMessage.status == 5
            "
            >已退款金额:￥0.00</span
          >
          <span class="money" v-else
            >已退款金额:￥{{ orderMessage.refundMoney }}</span
          >
        </div>
      </div>
      <div
        class="afterSaleBox"
        v-if="
          (routeQuery.afterType == 2 &&
            (orderMessage.status == 3 ||
              orderMessage.status == 4 ||
              orderMessage.status == 5 ||
              orderMessage.status == 6 ||
              orderMessage.status == 8)) ||
          (routeQuery.afterType == 1 &&
            (orderMessage.status == 3 ||
              orderMessage.status == 4 ||
              orderMessage.status == 5 ||
              orderMessage.status == 8))
        "
      >
        <div class="afterSaleBox_item">
          <div class="afterSaleBox_title">寄回信息</div>
        </div>
        <div class="afterSaleBox_item">
          <div class="message">
            <p>
              <span>退款地址</span
              ><span class="message_value" v-if="backInfo1">{{
                backInfo1.postAddress
              }}</span>
            </p>
            <p>
              <span>退货电话</span
              ><span class="message_value" v-if="backInfo1">{{
                backInfo1.postContact
              }}</span>
            </p>
            <p>
              <span>退货联系人</span
              ><span class="message_value" v-if="backInfo1">{{
                backInfo1.postName
              }}</span>
            </p>
            <!-- <p><span>物流部备注:</span><span class="message_value">{{afterSaleMessage.refundReason }}</span></p> -->
          </div>
        </div>
      </div>
    </div>
    <div class="botton_btn">
      <div
        v-if="
          (approveStatus || afterSaleMessage.subsetStatus == 1) &&
          parArray.indexOf('afterAuditCode') != -1 &&
          this.auditState == true
        "
      >
        <el-button class="whiteBtn" type="primary" @click="handlerAudit" plain
          >审核</el-button
        >
      </div>
    </div>
    <el-dialog title="售后申请" :visible.sync="isApplyDialog" append-to-body>
      <div style="margin-bottom: 10px">是否审核通过</div>
      <div style="margin-bottom: 10px">
        <el-radio-group v-model="radio">
          <el-radio label="1">通过</el-radio>
          <el-radio label="2">驳回</el-radio>
        </el-radio-group>
      </div>
      <div style="display: flex; margin-top: 10px" v-if="radio == 2">
        <div>备注</div>
        <div style="width: 90%; margin-left: 10px">
          <el-input
            type="textarea"
            maxlength="200"
            :rows="3"
            show-word-limit
            style="width: 100%"
            v-model="remark"
          >
          </el-input>
        </div>
      </div>
      <div style="margin-bottom: 10px" v-if="radio == 1">选择退货地址</div>
      <el-table :data="gridData" border @row-click="rowClick" v-if="radio == 1">
        <el-table-column prop="select" width="50">
          <template slot-scope="scope">
            <el-radio v-model="radioIdSelect" :label="scope.row.id"
              >&nbsp;</el-radio
            >
          </template>
        </el-table-column>
        <el-table-column prop="name" label="收货人姓名" width="200">
        </el-table-column>
        <el-table-column prop="phone" label="收货人电话" width="200">
        </el-table-column>
        <el-table-column prop="address" label="收货地址"> </el-table-column>
      </el-table>
      <div style="margin-top: 20px; text-align: center">
        <el-button @click="isApplyDialog = false">取消</el-button>
        <el-button type="primary" @click="saveApply()">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="物流信息"
      :visible.sync="dialogLook"
      append-to-body
      width="40%"
    >
      <StepLogistics :stepProgress="logisticsMessage"></StepLogistics>

      <div style="margin-top: 20px; text-align: center">
        <el-button @click="dialogLook = false" plain style="margin-right: 20px"
          >取消</el-button
        >
        <el-button type="primary" @click="dialogLook = false">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="温馨提示"
      :visible.sync="isInfo"
      width="518px"
      :append-to-body="true"
    >
      <template>
        <div style="font-size: 20px">是否确认收货?</div>
        <div v-if="orderMessage.status == '6'">
          请确认平台用户是否收货，该操作不可修改！
        </div>
        <div v-else>请确认仓库收货，该操作不可修改！</div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isInfo = false">取消</div>
          <div class="info-s" @click="submitInfo">确定</div>
          <!-- <el-button type="primary" plain @click="isUp = false">取消</el-button>
          <el-button type="primary" @click="isUp = false">确定</el-button> -->
        </div>
      </template>
    </el-dialog>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      append-to-body
      width="40%"
    >
      <div style="margin-bottom: 10px">
        <el-form
          ref="dialogForm"
          :model="dialogForm"
          label-width="80px"
          :rules="rules"
        >
          <el-form-item label="物流公司" prop="logisticsCompany">
            <el-select
              style="width: 100%"
              v-model="dialogForm.logisticsCompany"
              placeholder="请选择物流公司"
              filterable
            >
              <el-option
                v-for="(item, index) in dictionaries.courier_company"
                :key="index"
                :label="item.dictName"
                :value="item.dictId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="物流单号" prop="logisticsNumber">
            <el-input
              v-model="dialogForm.logisticsNumber"
              placeholder="请输入物流单号"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div style="margin-top: 20px; text-align: center">
        <el-button
          @click="dialogVisible = false"
          plain
          style="margin-right: 20px"
          >取消</el-button
        >
        <el-button type="primary" @click="submit">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible1" append-to-body>
      <img
        width="100%"
        fit="contain"
        :src="dialogImageUrl"
        alt=""
        style="width: 100%"
      />
    </el-dialog>
  </div>
</template>

<script>
import Steps from './components/shouhou-steps.vue'
import Steps1 from './components/shouhou-steps1.vue'
import Steps2 from './components/shouhou-steps2.vue'
import breadcrumb from '@/components/breadcrumb'
import VerticalSteps from '@/components/vertical-steps.vue'
import mixinsCommon from './mixins/common'
import AuditOperation from '@/components/AuditOperation'
import modifyOrderNo from './components/modifyOrderNo'
import StepLogistics from './components/StepLogistics'
export default {
  mixins: [mixinsCommon],
  name: 'afterSaleDetails',
  components: {
    Steps,
    Steps1,
    Steps2,
    breadcrumb,
    VerticalSteps,
    modifyOrderNo,
    AuditOperation,
    StepLogistics

  },
  data () {
    return {
      dialogVisible1: false,
      dialogImageUrl: '',
      imgs: [],
      title: '发货',
      dialogVisible: false,
      typeI: '',
      isInfo: false,
      dialogLook: false,
      gridData: [],
      remark: '',
      radio: '1',
      isApplyDialog: false,
      userId: '', //
      approveStatus: '', // 审核页面跳转传参
      stepClickType: '',
      exchangeGoodsList: {}, // 换货物流数据
      salesReturn: {}, // 退货物流数据
      afterStatus: '', // 订单状态
      LogisticsType: '', // 退货换货类型：1->退货；2->换货；
      disabledType: '', // 是否禁用取消售后按钮
      exchange: '', // 换货物流
      dialogForm: {
        logisticsCompany: '',
        logisticsNumber: '',
      },
      logisticsMessage: {},
      orderDetailList1: [],
      orderDetailList2: [],
      rules: {

        logisticsCompany: [
          { required: true, message: '请选择物流公司', trigger: 'change' }
        ],
        logisticsNumber: [
          { required: true, message: '请输入物流单号', trigger: 'blur' },
        ],
      },
      buyMessage: {}, // 购买信息
      orderMessage: '', // 订单信息
      afterSaleNode: {}, // 状态节点
      afterSaleMessage: '', // 售后退款信息
      goodsList: [], // 商品列表数据
      afterSaleId: '', // 售后订单ID
      cause: '',
      routeQuery: {}, // 路由参数

      shenhe: '2', // 审核
      statusImg: {
        close: require('../../assets/icon_guanbi.png'),
        open: require('../../assets/icon_wanc.png')
      },

      breadcrumbConfig: {
        list: [
          {
            title: '订单管理',
            type: '#ff0000',
            path: '/'
          },
          {
            title: '售后订单',
            type: '0',
            path: '/platformAfterOrderList'
          },
          {
            title: '售后详情',
            type: '1',
            path: ''
          }

        ]
      },
      remark: '',
      activeNum: 2,
      roleForm: {
        name: ''
      },
      page: {
        pageNo: 1,
        pageSize: 10,
        totalNum: 0,
        currentPage: 1
      },
      parArray: [],
      reallyName: '',
      auditState: false,
      radioIdSelect: '',
      addressInfo: {
        name: '',
        phone: '',
        address: ''
      },
      dictionaries: {},
      backInfo: {},
      backInfo1: {},
      orderId: null,
      time: 0,
    }
  },
  watch: {
    // afterStatus (val, oldVal) {
    //   if (val == 3) {
    //     this.LogisticsType = 1
    //     this.selectReturn() // 订单状态物流信息
    //   } else if (val == 5) {
    //     this.LogisticsType = 2
    //     this.selectExchangeGoods() // 订单状态物流信息
    //   }
    // }
  },
  created () {
    // 权限设定判断
    // this.limits = JSON.parse(sessionStorage.getItem('limit'))
    // const params = this.limits.buttonTreeDto.filter(
    //   (item) => item.menuCode === 'logisticsOrderList'
    // )
    // if (params.length > 0) {
    //   params[0].buttonList.forEach((item) => {
    //     this.parArray.push(item.code)
    //   })
    // }
    // // this.afterSaleId = this.$route.query.id
    // this.userId = JSON.parse(sessionStorage.getItem('user_id'))
    // this.reallyName = JSON.parse(sessionStorage.getItem('userInfo')).reallyName

    this.routeQuery = this.$route.query
    // this.fetchData()
    this.type = this.$route.query.type
    this.orderId = this.$route.query.id
    // this.approveStatus = this.$route.query.approveStatus
    // （状态节点）订单状态信息查询
    this.getAfterOrderStatus()
    // 售后订单状态退款信息查询
    // this.getRefund()
    // 售后订单商品信息查询
    // this.getDetail()
    this.getOrderDetail()// 订单信息
    // this.getBuyInfo()// 购买信息
    // this.getHistory()// 审核进度
    this.getDictionaries('courier_company')
    //获取寄货信息
    this.getReturnInfo1()
  },
  methods: {
    look (src) {
      console.log(src)
      this.dialogVisible1 = true
      this.dialogImageUrl = src
    },
    getReturnInfo1 () {
      let params = {
        id: this.$route.query.id
      }
      this.$api.getReturnLogistics(params).then((res) => {
        if (res.code == 0) {
          this.backInfo1 = res.data
        }
      }).catch((err) => {
        console.log(err)
      })

    },
    getReturnInfo () {
      let params = {
        id: this.$route.query.id
      }
      if (this.orderMessage.status == 6 || this.orderMessage.status == 8) {
        this.$api.getReturnLogistics1(params).then((res) => {
          if (res.code == 0) {
            this.backInfo = res.data
          }
        }).catch((err) => {
          console.log(err)
        })
      } else {
        this.$api.getReturnLogistics(params).then((res) => {
          if (res.code == 0) {
            this.backInfo = res.data
          }
        }).catch((err) => {
          console.log(err)
        })
      }

    },
    outGoods (type) {
      if (type == 'delivery') {
        this.title = '寄出换货'
        this.dialogVisible = true
      } else if (type == 'hedit') {
        this.title = '修改换货单号'
        this.dialogVisible = true
        this.dialogForm.logisticsNumber = this.orderMessage.logisticsNumber
        this.dialogForm.logisticsCompany = this.orderMessage.logisticsCompany
      } else if (type == 'fedit') {
        this.title = '填写退货单号'
        this.dialogVisible = true
      } else {
        this.title = '修改退货单号'
        this.dialogVisible = true
        this.dialogForm.logisticsNumber = this.orderMessage.logisticsNumber
        this.dialogForm.logisticsCompany = this.orderMessage.logisticsCompany
      }
    },
    // 获取字典数据
    getDictionaries (type) {
      const params = { groupId: type }
      this.$api.dictionaries(params).then((res) => {
        if (type == 'courier_company') {
          this.dictionaries.courier_company = res.data
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    stock (type) {
      this.isInfo = true
      this.typeI = type
    },
    submit () {
      this.$refs['dialogForm'].validate((valid) => {
        if (valid) {
          if (this.title == '填写退货单号') {
            let data = {
              orderAfterId: this.orderId,
              logisticsCompany: this.dialogForm.logisticsCompany,
              logisticsNumber: this.dialogForm.logisticsNumber
            }
            this.$api.addLogistics(data).then(res => {
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: '操作成功'
                })
                this.dialogVisible = false
                this.getOrderDetail()
                this.getAfterOrderStatus()
                this.getReturnInfo1()
              }

            })
          } else if (this.title == '寄出换货') {
            let data = {
              orderAfterId: this.orderId,
              logisticsCompany: this.dialogForm.logisticsCompany,
              logisticsNumber: this.dialogForm.logisticsNumber
            }
            this.$api.afterH(data).then(res => {
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: '操作成功'
                })
                this.dialogVisible = false
                this.getOrderDetail()
                this.getAfterOrderStatus()
                this.getReturnInfo1()
              }

            })
          } else {
            let type = 0
            if (this.title == '修改退货单号') {
              type = 1
            } else {
              type = 2
            }
            let data = {
              logisticsType: type,
              orderAfterId: this.orderId,
              logisticsCompany: this.dialogForm.logisticsCompany,
              logisticsNumber: this.dialogForm.logisticsNumber
            }
            this.$api.updateLogisticsNo(data).then(res => {
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: '操作成功'
                })
                this.dialogVisible = false
                this.getOrderDetail()
                this.getAfterOrderStatus()
                this.getReturnInfo1()
              }

            })
          }
        } else {
          return false;
        }
      });

    },
    submitInfo () {
      if (this.time == 0) {
        this.time = 10; //设定间隔时间（秒）
        //启动计时器，倒计时time秒后自动关闭计时器。
        var index = setInterval(function () {
          this.time--;
          if (this.time == 0) {
            clearInterval(index);
          }
        }, 1000);

        if (this.typeI == 'user') {
          let data = {
            id: this.orderId
          }
          this.$api.confirmUser(data).then(res => {
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '收货成功'
              })
              this.isInfo = false
              this.getOrderDetail()
              this.getAfterOrderStatus()
              this.getReturnInfo1()
            }
          })
        } else {
          let data = {
            id: this.orderId
          }
          this.$api.confirmFive(data).then(res => {
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '收货成功'
              })
              this.isInfo = false
              this.getOrderDetail()
              this.getAfterOrderStatus()
              this.getReturnInfo1()
            }
          })
        }
      } else {
        console.log('目前按钮事件不允许被触发');
      }

    },
    applyDialog () {
      this.isApplyDialog = true
      this.$api.afterAddressList({}).then(res => {
        if (res.code == 0) {
          this.gridData = res.data
        }
      })
    },
    saveApply () {
      if (this.time == 0) {
        this.time = 10; //设定间隔时间（秒）
        //启动计时器，倒计时time秒后自动关闭计时器。
        var index = setInterval(function () {
          this.time--;
          if (this.time == 0) {
            clearInterval(index);
          }
        }, 1000);
        let data = {
          status: Number(this.radio),
          id: this.$route.query.id,
          remark: this.remark,
          name: this.addressInfo.name,
          phone: this.addressInfo.phone,
          address: this.addressInfo.address
        }
        this.$api.saveAfterAudit(data).then(res => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '操作成功'
            });
            this.isApplyDialog = false
            this.getOrderDetail()
            this.getAfterOrderStatus()
            this.getReturnInfo1()
            // this.getReturnInfo()
          }
        })

      } else {
        console.log('目前按钮事件不允许被触发');
      }
      // let data = {
      //   status: Number(this.radio),
      //   id: this.$route.query.id,
      //   remark: this.remark,
      //   name: this.addressInfo.name,
      //   phone: this.addressInfo.phone,
      //   address: this.addressInfo.address
      // }
      // this.$api.saveAfterAudit(data).then(res => {
      //   if (res.code == 0) {
      //     this.$message({
      //       type: 'success',
      //       message: '操作成功'
      //     });
      //     this.isApplyDialog = false
      //     this.getOrderDetail()
      //   }
      // })
    },
    rowClick (row) {
      this.radioIdSelect = row.id
      this.addressInfo.name = row.name
      this.addressInfo.phone = row.phone
      this.addressInfo.address = row.address
    },
    // 审核
    confirmSelectPay () {
      if (this.shenhe == 3 && this.cause == '') {
        return this.$message.warning('请填写不通过原因！')
      }
      const data = {
        afterNos: [this.afterSaleMessage.afterNo],
        resultFlag: this.shenhe,
        reason: this.cause
      }
      this.$api.afterSaleDoApprove(data).then((res) => {
        if (res.code == 0) {
          this.$message.success('操作成功！')
          this.getAfterOrderStatus()
          this.getRefund()
          this.dialog.visible = false
        }
      }).catch(err => { console.log(err) })
    },
    stepClick (e) {
      if (e == 3) {
        this.salesReturn = {} // 退货物流数据
        this.exchangeGoodsList = {} // 换货物流数据
        this.dialog.title = '查看物流'
        this.dialog.type = 'logisticsInformationTwo'
        this.dialog.width = '948px'
        this.dialog.visible = true
        this.selectReturn()
        this.stepClickType = 3
      } else if (e == 5) {
        this.salesReturn = {} // 退货物流数据
        this.exchangeGoodsList = {} // 换货物流数据
        this.dialog.title = '查看物流'
        this.dialog.type = 'logisticsInformationTwo'
        this.dialog.width = '948px'
        this.dialog.visible = true
        this.selectExchangeGoods()
        this.stepClickType = 5
      }
    },
    // 审核，提交状态
    shenheState (state) {
      // 提交后，关闭并还原值
      this.closeDialog()
    },

    // 关闭退货 换货弹框
    modifyState (status, type) {
      if (type == 2) {
        this.disabledType = true
      }

      this.closeDialog()
      this.getAfterOrderStatus()
      this.getRefund()
    },
    // 寄出换货
    sendOff () {
      this.dialog.title = '寄出换货'
      this.dialog.type = 'exchangeGoods'
      this.dialog.visible = true
      this.dialog.width = '500px'
    },
    // 商品寄回
    sendBack () {
      this.dialog.title = '商品寄回'
      this.dialog.type = 'modifyOrderNoOneTui' // 换货不需要传值，显示组件使用，不作为值参使用
      this.dialog.visible = true
      this.dialog.width = '500px'
    },
    // （状态节点）订单状态信息查询
    getAfterOrderStatus () {
      const data = {
        id: this.routeQuery.id
      }
      this.$api.getOrderStatusAfter(data).then((res) => {
        if (res.code == 0) {
          this.afterSaleNode = res.data
        }
      }).catch(err => { console.log(err) })
    },
    // 售后订单状态退款信息查询
    getRefund () {
      const data = {
        id: this.routeQuery.id
      }
      this.$api.getRefundById(data).then((res) => {
        if (res.code == 0) {
          if (this.dictionaries.after_sale_status.length !== 0) {
            res.data.typeStatus = this.dictionaries.after_sale_status.find(e => { return e.dictId == res.data.status }).dictName
            res.data.refundCause = this.dictionaries.after_sale_reason.find(e => { return e.dictId == res.data.afterSaleReason }).dictName
          }
          this.afterSaleMessage = res.data
          this.afterStatus = this.afterSaleMessage.status
        }
      }).catch(err => { console.log(err) })
    },
    // 售后订单状态物流信息查询
    getLogistics (type) {
      // let type = 0
      // if (this.orderMessage.status == 6) {
      //   type = 1
      // } else {
      //   type = 2
      // }
      const params = {
        id: this.$route.query.id,
        logisticsType: type
      }
      this.$api.getLogisticsAfterDetail(params).then(res => {
        if (res.code == 0) {
          if (this.dictionaries.order_status_logistics.length !== 0 && res.data.status) {
            res.data.statusCn = this.dictionaries.order_status_logistics.find(e => { return e.dictId === res.data.status }).dictName
          }
          if (this.dictionaries.courier_company.length !== 0 && res.data.logisticsCompany) {
            res.data.logisticsCompanyCN = this.dictionaries.courier_company.find(e => { return e.dictId === res.data.logisticsCompany }).dictName
          }
          // console.log(logisticsCompany)
          this.logisticsMessage = res.data
          // this.logisticsMessage.logisticsCompany = logisticsCompany
        }
      })
    },
    // 查看换货物流信息
    selectExchangeGoods () {
      const data = {
        id: this.routeQuery.id
      }
      this.$api.selectExchangeGoodsById(data).then((res) => {
        if (res.code == 0) {
          res.data.data.map(item => {
            item.year = item.time.split(' ')[0]
            item.dataTime = item.time.split(' ')[1]
          })
          this.exchangeGoodsList = res.data
        }
      }).catch(err => { console.log(err) })
    },
    // 查看退货物流信息
    selectReturn () {
      const data = {
        id: this.routeQuery.id
      }
      this.$api.selectReturnById(data).then((res) => {
        if (res.code == 0) {
          res.data.data.map(item => {
            item.year = item.time.split(' ')[0]
            item.dataTime = item.time.split(' ')[1]
          })
          this.salesReturn = res.data
        }
      }).catch(err => { console.log(err) })
    },
    // 售后订单商品信息查询
    getDetail () {
      const data = {
        id: this.routeQuery.id
      }
      this.$api.getDetailById(data).then((res) => {
        if (res.code == 0) {
          this.goodsList = res.data
        }
      }).catch(err => { console.log(err) })
    },

    // 取消售后
    cancelAfterSale () {
      this.$confirm('是否撤回该售后审核？撤回后会取消审核', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = { afterNo: this.routeQuery.afterNo }
        this.$api.afterDoCancel(params).then((res) => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
            this.getAfterOrderStatus()
            this.getRefund()
          }
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {

      })
    },
    // 获取订单信息
    getOrderDetail () {
      const params = {
        id: this.routeQuery.id
      }
      this.$api.getOrderDetailAfter(params).then(res => {
        if (res.code == 0) {
          // if (this.dictionaries.order_pay_type.length !== 0) {
          //   res.data.payTypeCN = this.dictionaries.order_pay_type.find(e => { return e.dictId == res.data.payType }).dictName
          // }
          this.orderMessage = res.data
          res.data.orderAfterDetailList.forEach(item => {
            if (item.goodsType != 3) {
              this.orderDetailList1.push(item)
            } else {
              this.orderDetailList2.push(item)
            }
          })

          if (res.data.afterImages) {
            this.imgs = res.data.afterImages.split(',')
          }

          this.getReturnInfo()
        }
      })
    },
    // 获取订单购买信息
    getBuyInfo () {
      const data = {
        id: this.routeQuery.orderId
      }
      this.$api.getBuyInfo(data).then(res => {
        if (res.code == 0) {
          this.buyMessage = res.data
        }
      })
    },
    // 审核按钮
    handlerAudit () {
      this.shenhe = ''
      this.cause = ''
      this.dialog.type = 'audit'
      this.dialog.visible = true
      this.dialog.title = '审核'
      this.dialog.width = '600px'
    },
    // 添加备注确定按钮
    confirm () {

    },
    handleClose () {
      this.dialog.visible = false
    },
    // 查看物流按钮
    examine (val) {
      this.dialogLook = true
      this.getLogistics(val)
      // this.salesReturn = {} // 退货物流数据
      // this.exchangeGoodsList = {} // 换货物流数据
      // this.dialog.title = '查看物流'
      // this.dialog.type = 'logisticsInformation'
      // this.dialog.width = '948px'
      // this.dialog.visible = true
      // if (this.afterSaleMessage.subsetStatus == 3) { // 退货
      //   this.selectReturn()
      // } else if (this.afterSaleMessage.subsetStatus == 5) { // 换货
      //   this.selectExchangeGoods()
      // }
      // else {
      //   this.getlogistics()
      // }
      // this.selectReturn()
      // this.selectExchangeGoods()
    },
    // // 物流信息
    // getlogistics () {
    //   const data = {
    //     id: this.routeQuery.id,
    //     logisticsType: 2
    //   }
    //   this.$api.getLogisticsInfo(data).then(res => {
    //     if (res.code == 0) {
    //       res.data.data.map(item => {
    //         item.year = item.time.split(' ')[0]
    //         item.dataTime = item.time.split(' ')[1]
    //       })
    //       this.exchangeGoodsList = res.data
    //     }
    //   })
    // },
    // 添加备注按钮
    addRemarkBtn () {
      this.dialog.title = '添加备注'
      this.dialog.type = 'addRemark'
      this.dialog.width = '30%'

      this.dialog.visible = true
    },
    // 修改地址
    editLocation () {
      this.dialog.title = '修改收货地址'
      this.dialog.type = 'editLoacation'
      this.dialog.width = '50%'
      this.dialog.visible = true
    }

  }
}
</script>

<style scoped lang="scss">
.el-dialog .el-dialog__header {
  border-bottom: none;
}
.logisticsBtn {
  padding-top: 55px;
}
.boldSize {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
.boldSize16 {
  font-size: 18px;
  font-weight: 400;
  color: #333333;
}
.size14 {
  font-size: 16px;
  font-weight: 400;
  color: #666666;
}

@media screen and (max-width: 1280px) {
  .borderWire {
    width: 1px;
    background-color: #ededed;
    margin-top: 4.5% !important;
  }
  .logisticsBtn {
    padding-top: 3% !important;
  }
  .boldSize {
    font-size: 18px !important;
    font-weight: bold;
    color: #333333;
  }
  .boldSize16 {
    font-size: 16px !important;
    font-weight: 400;
    color: #333333;
  }
  .approver {
    margin-top: 10px;
    font-size: 16px !important;
    font-weight: 400;
  }
  .size14 {
    font-size: 14px !important;
    font-weight: 400;
    color: #666666;
  }
  .imgbox {
    margin-top: 10px;
    .img_item {
      width: 72px !important;
      height: 72px !important;
      padding-right: 10px;
      vertical-align: top;
    }
  }

  .contentDetails {
    margin-bottom: 20px;
    padding: 16px 20px !important;
    background-color: #ffffff;
    box-sizing: border-box;
    .box {
      padding: 0px 20px !important;
      background: #f5f8ff;
      box-sizing: border-box;
      padding-left: 25px;
    }
    .contentDetails_item {
      width: 50%;
      height: auto;
      text-align: left;
    }

    .afterSales {
      width: 120px;
      height: 36px;
      background: #ffffff;
      border: 1px solid #f33f3f;
      opacity: 1;
      border-radius: 4px;
      line-height: 0;
      color: #f33f3f;
    }
    .addressWidth {
      width: 560px !important;
    }
    .details {
      display: flex;
      flex-wrap: wrap;
      margin-top: 10px;
      .details_box {
      }
      .details_item {
        margin-right: 30px;
        width: auto !important;
        line-height: 40px;
        .details_title {
          width: 85px !important;
          font-size: 14px !important;
          font-weight: 400;
          line-height: 0px;
          color: #999999;
          text-align: right;
          display: inline-block;
        }

        .details_value {
          font-size: 14px !important  ;
          font-weight: 400;
          line-height: 0px;
          color: #666666;
          padding-left: 12px;
        }
      }
    }

    .remarkMessage {
      margin-top: 18px;
      .remarkMessage_remark {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .fourteenTitle_buymessage {
        margin-left: 28px !important;
      }
      .remarkMessage_remark_item {
        width: 50%;
        display: flex;
        align-items: center;
        margin-right: 10px;
      }
      .fourteenTitle {
        width: 62px;
        font-size: 14px;
        font-weight: bold;
        color: #333333;
      }
      .fourteenDetails {
        width: 78%;
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        padding-bottom: 0;
        background-color: #f5f8ff;
        margin-left: 10px;
        margin-right: 10px;

        padding-left: 10px;
      }
    }
    .title {
      font-size: 16px !important;
      font-weight: 400;
    }

    .title_too {
      font-size: 14px;
      font-weight: bold;
      color: #333333;
      margin-top: 18px;
      padding-left: 28px !important;
    }
    .titleblue {
      display: flex;
      align-items: center;
      &:before {
        display: inline-block;
        content: "";
        width: 4px;
        height: 16px;
        background-color: #2d7edf;
        margin-right: 10px;
      }
    }
    .titleBtn {
      display: flex;
      justify-content: space-between;
    }
  }
}

.contentDetails {
  margin-bottom: 20px;
  padding: 16px 20px;
  background-color: #ffffff;
  box-sizing: border-box;
  .borderWire {
    width: 1px;
    background-color: #ededed;
    margin-top: 0%;
    margin-left: 8%;
    margin-right: 2%;
  }
  .contentDetails_box {
    display: flex;
    justify-content: left;

    .details {
      display: flex;
      flex-wrap: wrap;
      margin-top: 10px;
      // margin-right: 250px;

      .contentDetails_item {
        display: flex;
      }
      .details_item {
        min-width: 100px;
        line-height: 40px;
        .details_title {
          width: 82px;
          text-align: right;
          font-size: 16px;
          font-weight: 400;
          line-height: 0px;
          color: #999999;
          display: inline-block;
        }
        .details_value {
          font-size: 16px;
          font-weight: 400;
          line-height: 0px;
          color: #666666;
          padding-left: 12px;
        }
      }
    }
  }
  .addressWidth {
    // width: 560px !important;
  }

  .order_details {
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
    margin-top: 10px;
    .blankBox {
      width: 3%;
    }
    // min-width: 255px;
    line-height: 40px;
    .order_details_title {
      width: 82px;
      font-size: 14px;
      font-weight: 400;
      line-height: 0px;
      color: #999999;
      text-align: right;
      display: inline-block;
    }

    .order_details_value {
      font-size: 14px;
      font-weight: 400;
      line-height: 0px;
      color: #666666;
      padding-left: 12px;
    }
  }
}
.fourteenDetails_title {
  font-size: 14px;
  font-weight: bold;
  color: #333333;
  margin-bottom: 10px;
  margin-top: 20px;
}
.red {
  color: red !important;
}
.remarkMessage {
  margin-top: 18px;
  .remarkMessage_remark {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .remarkMessage_remark_item {
    width: 50%;
    display: flex;
    align-items: center;
    margin-right: 10px;
  }
  .fourteenTitle {
    font-size: 14px;
    font-weight: bold;
    color: #333333;
  }
  .fourteenDetails {
    width: 78%;
    height: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    padding-bottom: 0;
    background-color: #f5f8ff;
    margin-left: 10px;
    margin-right: 10px;

    padding-left: 10px;
  }
}
.title {
  font-size: 16px;
  font-weight: 400;
}

.title_too {
  font-size: 14px;
  font-weight: bold;
  color: #333333;
  margin-top: 18px;
  padding-left: 25px;
}
.titleblue {
  display: flex;
  align-items: center;
  &:before {
    display: inline-block;
    content: "";
    width: 4px;
    height: 16px;
    background-color: #2d7edf;
    margin-right: 10px;
  }
}
.titleBtn {
  display: flex;
  justify-content: space-between;
}
.box {
  padding: 0px 39px;
  background: #f5f8ff;
  box-sizing: border-box;
}

.fourteenTitle {
  font-size: 14px;
  font-weight: bold;
  color: #333333;
}
.fourteenDetails {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  padding-bottom: 20px;
}

.red {
  color: red;
}
.total_prices {
  margin-top: 24px;
  display: flex;
  justify-content: right;
  font-size: 14px;
}
.botton_btn {
  padding: 10px 20px 20px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dialogBtn {
  display: flex;
  justify-content: right;
  margin-top: 28px;
}

.afterSaleBox {
  border-top: 1px solid #ededed;
  margin-top: 10px;
  padding: 20px 20px 0px 20px;
  .afterSaleBox_title {
    font-size: 14px;
    font-weight: bold;
    color: #333333;
  }
  .afterSaleBox_item {
    display: flex;
    justify-content: space-between;
    .message {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      p {
        padding-top: 8px;
      }
      .message_value {
        padding-left: 10px;
      }
    }
    .imgbox {
      .imgbox_title {
        padding-right: 10px;
      }
      .img_item {
        width: 88px;
        height: 88px;
        padding-right: 10px;
        vertical-align: top;
      }
    }
  }
}
.whiteBtn {
  width: 120px;
  height: 36px;
  background: #ffffff;
  border: 1px solid #4168e7;
  opacity: 1;
  border-radius: 4px;
  line-height: 0;
  color: #4168e7;
}
.tuikuan {
  font-size: 18px;
  font-weight: bold;
  display: flex;
  justify-content: right;
  margin-top: 10px;
  .tuikuan_status {
    color: #f33f3f;
    padding-right: 20px;
  }
  .money {
    color: #f33f3f;
  }
}
.fourteen {
  font-size: 14px !important;
}
.dialogBtnright {
  display: flex;
  justify-content: right;
}
.setPay_payment_btn_quxiao {
  width: 120px;
  height: 36px;
  border: 1px solid #d9d9d9;
  opacity: 1;
  border-radius: 4px;
  line-height: 0;
}
.setPay_payment_btn_queren {
  width: 120px;
  height: 36px;
  background: #4168e7;
  opacity: 1;
  border-radius: 4px;
  line-height: 0;
  border: 0;
}
.audit_textarea {
  margin-top: 10px;
  /deep/.el-textarea__inner {
    margin-top: 13px;
    height: 132px;
  }
}
.audit_title {
  font-weight: bold;
  margin-bottom: 20px;
  font-size: 16px;
}

.whiteBtn {
  width: 120px;
  height: 36px;
  background: #ffffff;
  border: 1px solid #4168e7;
  opacity: 1;
  border-radius: 4px;
  line-height: 0;
  color: #4168e7;
}
/deep/.el-table th > .cell {
  text-align: unset;
  font-size: 16px;
}
.goodsMessage {
  .gift {
    display: inline-block;
    text-align: center;
    width: 54px;
    height: 24px;
    background: #feebeb;
    border-radius: 4px;
    margin-left: 25px;
    font-size: 14px;
    font-weight: 400;
    color: #f33f3f;
    line-height: 23px;
    box-sizing: border-box;
  }
}
.platform {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
}
.platformMoney {
  font-size: 16px;
  font-weight: 400;
  color: #f33f3f;
}
.info {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 0px;
  color: #303033;
  opacity: 1;
  text-align: left;
}
.info-b {
  margin-left: 20px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 40px;
  color: #303033;
  text-align: left;
}
.info-q {
  width: 124px;
  height: 40px;
  line-height: 40px;
  background: #ffffff;
  border: 1px solid #909099;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #909099;
  margin-right: 18px;
}
.info-s {
  width: 126px;
  height: 40px;
  line-height: 40px;
  background: rgb(64, 158, 255);
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
</style>
